"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CurrencyContext = require("./CurrencyContext");
var flags = {
  EUR: '🇪🇺',
  USD: '🇺🇸',
  GBP: '🇬🇧',
  AUD: '🇦🇺',
  CAD: '🇨🇦'
};
var getLabel = function getLabel() {
  var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EUR';
  var flag = flags[currency];
  var symbol;
  if (typeof Intl === 'undefined' || !Intl.NumberFormat) {
    console.warn('Intl is not found, using simple polyfill');
    switch (currency) {
      case 'GBP':
        symbol = '£';
        break;
      case 'USD':
        symbol = '$';
        break;
      case 'AUD':
        symbol = 'A$';
        break;
      case 'CAD':
        symbol = 'CA$';
        break;
      default:
        symbol = '€';
    }
  } else {
    var str = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(0);
    symbol = str.split('0')[0];
  }
  return "".concat(flag, " ").concat(symbol);
};
var CurrencyDropdown = function CurrencyDropdown(_ref) {
  var currencies = _ref.currencies;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "dropdown-menu-hover relative menu-currency-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_CurrencyContext.CurrencyContext.Consumer, null, function (context) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "menu-currency"
    }, /*#__PURE__*/_react["default"].createElement("span", null, getLabel(context.currency)), /*#__PURE__*/_react["default"].createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "dropdown-menu outline"
    }, currencies.map(function (c) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: c
      }, /*#__PURE__*/_react["default"].createElement("span", {
        onClick: function onClick() {
          return context.changeCurrency(c);
        }
      }, getLabel(c)));
    })));
  }));
};
CurrencyDropdown.propTypes = {
  currencies: _propTypes["default"].array
};
CurrencyDropdown.defaultProps = {
  currencies: ['EUR', 'USD', 'GBP', 'AUD', 'CAD']
};
var _default = exports["default"] = CurrencyDropdown;